import javascriptIcon from "../assets/skills-logos/javascript.svg";
import awsIcon from "../assets/skills-logos/aws.svg";
import expressIcon from "../assets/skills-logos/expressjs.svg";
import githubIcon from "../assets/skills-logos/github.svg";
import javaIcon from "../assets/skills-logos/java.svg";
import mysqlIcon from "../assets/skills-logos/mysql.svg";
import nodejsIcon from "../assets/skills-logos/nodejs.svg";
import reactjsIcon from "../assets/skills-logos/reactjs.svg";
import responsiveIcon from "../assets/skills-logos/responsive.svg";
import sassIcon from "../assets/skills-logos/sass.svg";
import htmlIcon from "../assets/skills-logos/html5.svg";
// import springIcon from "../assets/skills-logos/springio.svg";
import typescriptIcon from "../assets/skills-logos/typescript.svg";

const skills = [
  {
    skill: "Javascript",
    percentage: 60,
    url: `${javascriptIcon}`,
  },
  {
    skill: "NodeJS",
    percentage: 50,
    url: `${nodejsIcon}`,
  },
  {
    skill: "React",
    percentage: 50,
    url: `${reactjsIcon}`,
  },
  {
    skill: "Express",
    percentage: 40,
    url: `${expressIcon}`,
  },
  {
    skill: "MYSQL",
    percentage: 30,
    url: `${mysqlIcon}`,
  },
  {
    skill: "HTML/CSS",
    percentage: 60,
    url: `${htmlIcon}`,
  },
  {
    skill: "SCSS",
    percentage: 40,
    url: `${sassIcon}`,
  },
  {
    skill: "AWS",
    percentage: 30,
    url: `${awsIcon}`,
  },
  {
    skill: "GIT",
    percentage: 40,
    url: `${githubIcon}`,
  },
  {
    skill: "JAVA",
    percentage: 20,
    url: `${javaIcon}`,
  },
  {
    skill: "Responsive Design",
    percentage: 60,
    url: `${responsiveIcon}`,
  },
  {
    skill: "Typescript",
    percentage: 60,
    url: `${typescriptIcon}`,
  },
];

export default skills;
